module.exports = __webpack_public_path__ + "img/user.4a516402.svg";